
import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { Location } from "vue-router";
import useDarkModeController from "@/hooks/useDarkModeController";
import { DARK_LOGO_URL, LOGO_URL } from "@/lib/urlHelpers";

interface Props {
  href?: string;
  to?: Location;
  imgClass?: string;
  small?: boolean;
}

export default Vue.extend({
  name: "SiteLogo",
  functional: true,
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { href, to, imgClass, small = true } = ctx.props;
    const { isDarkMode } = useDarkModeController();
    const classes = [...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]), ctx.data.staticClass];
    const imgLogo = h("img", {
      staticClass: "logo",
      class: [...(!href && !to ? classes : []), imgClass, { __small: small }],
      attrs: {
        src: isDarkMode.value ? DARK_LOGO_URL : LOGO_URL,
        alt: "logo",
      },
      on: ctx.listeners.load
        ? {
            load: ctx.listeners.load,
          }
        : {},
    });
    if (href) return h("a", { class: classes, attrs: { href } }, [imgLogo]);
    if (to) return h("router-link", { class: classes, props: { to } }, [imgLogo]);
    return imgLogo;
  },
});
